export default __webpack_public_path__ + "static/media/Tvs.ba2ccfd5.png";